import { FC, PropsWithChildren } from 'react'

import { usePage } from '@editor/hooks/page'
import { Outlet } from 'react-router'

const RouteProjectsLayout: FC<PropsWithChildren> = ({ children }) => {
  usePage()

  return children ?? <Outlet />
}

export default RouteProjectsLayout
